import { useTranslation } from "react-i18next";
import {
    clearToasts,
    dismissToast,
    showErrorToast as showGlobalErrorToast,
    showSuccessToast as showGlobalSuccessToast,
} from "./toastService";

const useToast = () => {
    const { t } = useTranslation("commonTranslation");
    const buildOptionsWithSummary = (summaryKey, options = {}) => ({
        ...options,
        summary: options?.summary ?? t(summaryKey),
    });

    const showSuccessToast = (message = t("toastMessages.success"), options = {}) => {
        return showGlobalSuccessToast(
            message,
            buildOptionsWithSummary("toastMessages.successSummary", options)
        );
    };

    const showErrorToast = (message = t("toastMessages.error"), options = {}) => {
        return showGlobalErrorToast(
            message,
            buildOptionsWithSummary("toastMessages.errorSummary", options)
        );
    };

    return {
        showSuccessToast,
        showErrorToast,
        dismissToast,
        clearToasts,
        showSuccess: showSuccessToast,
        showError: showErrorToast,
    };
};

export default useToast;
